var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"py-1 px-0 d-block"},[_c('v-list-item-icon',{staticClass:"ma-0 d-block text-center"},[_vm._t("icon")],2),_c('v-list-item-title',{staticClass:"mt-3 d-block text-center"},[_vm._t("text")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }